export const unauthedUserConstants = {
    RECIEVE_COUNTRY_INFO: 'RECIEVE_COUNTRY_INFO',
    ERROR_COUNTRY_INFO: 'ERROR_COUNTRY_INFO',
};
